function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M12.75 3C12.5625 4.3125 13.6875 5.4375 15 5.25M8.25 9.75L8.67754 8.03983C8.79757 7.55974 8.85758 7.3197 8.95408 7.09589C9.03975 6.8972 9.14667 6.70836 9.27297 6.53266C9.41523 6.33477 9.59019 6.15981 9.94011 5.80989L13.125 2.625C13.1847 2.56526 13.2146 2.53539 13.2411 2.51135C13.8132 1.99131 14.6868 1.99131 15.2589 2.51135C15.2854 2.53539 15.3153 2.56526 15.375 2.625C15.4347 2.68474 15.4646 2.71461 15.4886 2.74106C16.0087 3.31317 16.0087 4.18683 15.4886 4.75894C15.4646 4.78539 15.4347 4.81526 15.375 4.875L12.1901 8.05989C11.8402 8.40981 11.6652 8.58477 11.4673 8.72703C11.2916 8.85333 11.1028 8.96025 10.9041 9.04592C10.6803 9.14242 10.4403 9.20243 9.96017 9.32246L8.25 9.75Z",
  stroke: "#1B1C1C",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 1.5H8.625H7.5C5.3998 1.5 4.3497 1.5 3.54754 1.90873C2.84193 2.26825 2.26825 2.84193 1.90873 3.54754C1.5 4.3497 1.5 5.3998 1.5 7.5V10.5C1.5 12.6002 1.5 13.6503 1.90873 14.4525C2.26825 15.1581 2.84193 15.7317 3.54754 16.0913C4.3497 16.5 5.3998 16.5 7.5 16.5H10.5C12.6002 16.5 13.6503 16.5 14.4525 16.0913C15.1581 15.7317 15.7317 15.1581 16.0913 14.4525C16.5 13.6503 16.5 12.6002 16.5 10.5V9.375V9",
  stroke: "#54606B",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcEditHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditHome);
export default __webpack_public_path__ + "static/media/ic_edit_home.69366f92.svg";
export { ForwardRef as ReactComponent };